import { DataTestIds } from '@repo/frontend-shared';
import { SDSFlexbox } from '@repo/sds/SDSFlexbox';
import { SDSSwitch } from '@repo/sds/SDSSwitch';
import { SDSText } from '@repo/sds/SDSText';

import { defaultTimeRange } from '../../constants/time';
import { useAvailability } from '../../hooks/use-availability';
import { DayTimeRangeSelector } from '../DayTimeRangeSelector/DayTimeRangeSelector';

import './DayAvailability.scss';

interface DayAvailabilityProps {
  day: string;
}

export function DayAvailability({ day }: DayAvailabilityProps) {
  const { availability, toggleDay } = useAvailability();
  const { isAvailable, timeRanges } = availability[day];

  // Always show at least one time range selector with default values
  const displayTimeRanges = timeRanges.length > 0 ? timeRanges : [defaultTimeRange];

  return (
    <SDSFlexbox
      justifyContent="space-between"
      alignItems="baseline"
      className="DayAvailability"
      dataTestId={DataTestIds.ONBOARDING.DAY_AVAILABILITY}
    >
      <SDSFlexbox alignItems="center" gap="text-large">
        <SDSSwitch
          checked={isAvailable}
          onChange={() => toggleDay(day)}
          tabIndex={0}
          aria-label={`Toggle availability for ${day}`}
          data-testid={DataTestIds.SDS.SDS_SWITCH}
        />
        <SDSText text={day} type="body-large-bold" />
      </SDSFlexbox>
      <SDSFlexbox justifyContent="space-between" alignItems="center" direction="column">
        {displayTimeRanges.map((range, index) => (
          <DayTimeRangeSelector
            key={`${range.start}-${range.end}`}
            day={day}
            timeRange={range}
            index={index}
            disabled={!isAvailable}
          />
        ))}
      </SDSFlexbox>
    </SDSFlexbox>
  );
}
